import script from "./phoneView.vue?vue&type=script&setup=true&lang=js"
export * from "./phoneView.vue?vue&type=script&setup=true&lang=js"

import "./phoneView.vue?vue&type=style&index=0&id=4502805c&lang=css"

const __exports__ = script;

export default __exports__